<template>
  <v-app id="app-layout">
    <v-main>
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters class="fill-height">
          <v-col
            :order="$vuetify.breakpoint.mdAndUp ? 1 : 2"
            cols="12"
            class="white"
            :class="{
              sidenav: $vuetify.breakpoint.mdAndUp && this.$store.state.map.show,
              bottomNav: $vuetify.breakpoint.smAndDown && this.$store.state.map.show,
              expanded: $store.state.map.collapsed
            }"
          >
            <router-view
              :key="$route.fullPath"
              @setMapVessel="setMapVessel"
              @setMapOrganization="setMapOrganization"
              @toggleDrawer="toggleDrawer"
              @showUserProfileUpdateDialog="showUserProfileUpdateDialog"
              @setUserInfo="setUserInfo"
            >
            </router-view>
          </v-col>
          <v-col
            v-if="loggedIn && $route.name !== 'authCallback'"
            v-show="this.$store.state.map.show"
            :cols="$vuetify.breakpoint.smAndDown ? 12 : null"
            :order="$vuetify.breakpoint.mdAndUp ? 2 : 1"
            :class="{
              topMap: $vuetify.breakpoint.smAndDown,
              collapsed: $store.state.map.collapsed
            }"
          >
            <Map></Map>
          </v-col>
        </v-row>

        <v-navigation-drawer
          v-if="loggedIn && userInfo && userInfo.sub && $security.isAllowed()"
          v-model="drawer"
          :fixed="drawerConfig.fixed"
          :temporary="drawerConfig.temporary"
          :permanent="drawerConfig.permanent"
          :app="drawerConfig.app"
        >
          <AppDrawer :user-info="userInfo" @showUserProfileUpdateDialog="showUserProfileUpdateDialog"></AppDrawer>
        </v-navigation-drawer>
      </v-container>
    </v-main>

    <!--
      <v-footer color="secondary" app class="px-3">
          <span class="white--text">USAIL &copy; 2018</span>
      </v-footer>
      -->
    <UserProfileUpdateDialog
      v-if="userProfile"
      :show="userProfileUpdateDialog"
      :userprofile-iri="userProfile['@id']"
      @showUserProfileUpdateDialog="showUserProfileUpdateDialog"
    ></UserProfileUpdateDialog>
  </v-app>
</template>

<script>
import Map from '@/views/Map'
import AppDrawer from '@/components/AppDrawer'
import UserProfileUpdateDialog from '@/components/userprofile/UpdateDialog'

export default {
  components: {
    Map,
    AppDrawer,
    UserProfileUpdateDialog
  },
  data() {
    return {
      drawer: false,
      userInfo: {},
      mapVessel: {},
      mapOrganization: {},
      userProfileUpdateDialog: false,
      userProfile: null
    }
  },

  computed: {
    loggedIn: function() {
      return this.$keycloak.authenticated
    },

    drawerConfig: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return {
          fixed: true,
          temporary: true,
          permanent: false,
          app: false
        }
      }

      if (this.$store.state.map.show || 'authCallback' === this.$route.name) {
        return {
          fixed: true,
          temporary: true,
          permanent: false,
          app: false
        }
      } else {
        return {
          fixed: false,
          temporary: false,
          permanent: true,
          app: true
        }
      }
    }
  },

  watch: {
    loggedIn(loggedIn) {
      if (!loggedIn) {
        return
      }
    }
  },

  mounted: function() {
    this.userInfo = this.$security.getUser()

    if ('es' === navigator.language.substr(0, 2)) {
      this.$i18n.locale = 'es'
      this.$moment.locale('es')
    } else {
      this.$i18n.locale = 'en'
      this.$moment.locale('en')
    }
  },

  methods: {
    login: function() {
      this.$keycloak.login()
    },
    logout: function() {
      this.$keycloak.logout()
    },
    setMapVessel(vessel) {
      this.mapVessel = vessel
    },
    setMapOrganization(organization) {
      this.mapOrganization = organization
    },
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    showUserProfileUpdateDialog(userProfile) {
      this.userProfile = userProfile
      this.userProfileUpdateDialog = !!userProfile
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo
    }
  }
}
</script>

<style lang="scss">
.full-height {
  height: 100%;
}

.has-fab {
  padding-bottom: 50px !important;
}

.content--wrap {
  display: flex;
}

.layout-sidenav {
  flex: 1 1 auto;
  position: relative;
  height: 100%;
}

.v-main {
  max-height: 100vh;
}

.topMap {
  height: 50%;
  max-height: 50%;
  min-height: 50%;
  &.collapsed {
    height: 0;
    max-height: 0;
    min-height: 0;
    overflow: hidden;
  }

  transition: height 300ms linear, max-height 300ms linear, min-height 300ms linear;
}
.bottomNav {
  height: 50%;
  max-height: 50%;
  min-height: 50%;
  overflow-y: auto;
  &.expanded {
    height: 100%;
    max-height: 100%;
    min-height: 100%;
  }

  transition: height 300ms linear, max-height 300ms linear, min-height 300ms linear;
}
.sidenav {
  width: 350px;
  max-width: 350px;
  flex: 1 1 auto;
  overflow-y: auto;
  height: calc(100vh - 64px);
}

.sidenav-fab {
  bottom: 20px;
  left: 260px;
  &.sidenav-fab-sm {
    right: 20px;
    left: auto;
  }
}

.sidenav-speed-dial {
  position: fixed;
  bottom: 20px;
  left: 260px;
  &.sidenav-speed-dial-sm {
    right: 20px;
    left: auto;
  }
}

.sidenav-body {
  padding-bottom: 60px;
}

.drawer-brand {
  display: block;
  padding: 14px 14px 8px 14px;
  img {
    max-height: 36px;
  }
}

.container.page {
  max-width: 1185px !important;
  padding-top: 32px;
  padding-bottom: 48px;
  height: 100%;
}

.page {
  max-width: 1185px;
  margin: auto;
  width: 100%;
}

.content--wrap {
  position: relative;
}

.content-spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-bottom: 3rem;
}

.map {
  width: 100%;
  height: 100%;
}

/*
      .navigation-drawer {
        padding-top: 64px;
        padding-bottom: 0;
      }

      .drawer-content {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
      }
      */

.table-alt {
  td {
    padding: 0.5rem 3rem 0.5rem 0;
  }
}

.text-uppercase {
  text-transform: uppercase;
}

.layout-gap {
  margin: -1rem;
  .flex {
    padding: 1rem;
  }
}

.drawer-head {
  display: none;
}

.sidenav {
  position: relative;
}
.sidenav-body {
}

.no-decoration {
  text-decoration: none;
}

.sticky {
  position: sticky;

  &.bottom {
    bottom: 0;
  }

  &.right {
    text-align: right;
  }
}

.d-flex-alt {
  display: flex;
}

.drawer-tabs {
  .tabs__wrapper,
  .tabs__bar {
    width: 300px;
    overflow: hidden;
  }
  .tabs__container {
    height: 72px;
    justify-content: center;
    .tabs__div {
      flex: auto 1 1;
      .tabs__item {
      }
    }
  }
}

.empty-state-sm {
  padding: 20px;
  text-align: center;
}

.text-capitalize-first:first-letter {
  text-transform: uppercase;
}

.croppa-container {
  border-radius: 50%;
  border: 4px solid white;
  > canvas {
    border-radius: 50%;
  }

  svg.icon-remove {
    -webkit-filter: drop-shadow(0 0) !important;
    filter: drop-shadow(0 0) !important;
    right: 2% !important;
    top: 2% !important;
    width: 18%;
    height: 18%;
  }
}

.muted {
  opacity: 0.8;
}

.table-pointer tbody tr {
  cursor: pointer;
}
</style>
